import { IModelRaw } from './base';

export enum ENewsletterType {
  Investor = 'investor',
  Startup = 'startup',
  Researcher = 'researcher',
}

export interface INewsletter extends IModelRaw {
  subject_en: string;
  subject_vi: string;
  content_en: string;
  content_vi: string;
  newsletter_type: ENewsletterType;
  sent_at: string;
  recipient_count: number;
}

export interface ICreateNewsletterRequest {
  subject_en: string;
  subject_vi: string;
  content_en: string;
  content_vi: string;
  newsletter_type: ENewsletterType;
}